module.exports = __webpack_public_path__ + "img/OnTheRoad.c1da660b.svg";